export function buildAvartarByString(name?: string | null): string {
    if (!name) return 'U'

    const trimmed = name.trim()
    if (!trimmed) return 'U'

    const parts = trimmed.split(/\s+/)

    if (parts.length >= 2) {
        const first = parts[0]?.[0] ?? ''
        const last = parts[parts.length - 1]?.[0] ?? ''
        return (first + last).toUpperCase()
    }

    return trimmed.slice(0, 2).toUpperCase()
}

/**
 * Formats a date string or Date object into a localized string (vi-VN)
 */
export function formatDate(date?: string | Date | number | null): string {
    if (!date) return ''

    try {
        const d = date instanceof Date ? date : new Date(date)
        if (isNaN(d.getTime())) return String(date)

        return new Intl.DateTimeFormat('vi-VN', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        }).format(d)
    } catch (e) {
        return String(date)
    }
}

/**
 * Formats a number with thousand separators (vi-VN)
 */
export function formatNumber(val: any): string {
    if (val === undefined || val === null || val === '') return ''
    const s = String(val).replace(/[^\d.-]/g, '')
    const n = parseFloat(s)
    if (isNaN(n)) return ''
    return new Intl.NumberFormat('vi-VN').format(n)
}

/**
 * Formats a phone number into Vietnamese format: 0XXX XXX XXX
 */
export function formatPhoneNumber(val: any): string {
    if (!val) return ''
    const s = String(val).replace(/\D/g, '')
    if (s.length <= 4) return s
    if (s.length <= 7) return `${s.slice(0, 4)} ${s.slice(4)}`
    return `${s.slice(0, 4)} ${s.slice(4, 7)} ${s.slice(7, 11)}`
}